// src/context/UserContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import { safeLocalStorage } from '../utils/ssrSafe';
import { hasStoredGoogleIdToken } from '../utils/googleAuth';

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  // Start with null for SSR compatibility, load from localStorage after hydration
  const [user, setUserState] = useState(null);

  // Load user from localStorage after component mounts (client-side only)
  useEffect(() => {
    const storedUser = safeLocalStorage.getItem('user');
    if (storedUser && hasStoredGoogleIdToken()) {
      try {
        setUserState(JSON.parse(storedUser));
      } catch (e) {
        // Ignore malformed JSON in localStorage
        safeLocalStorage.removeItem('user');
      }
    } else if (storedUser) {
      safeLocalStorage.removeItem('user');
      safeLocalStorage.removeItem('userData');
    }
  }, []);

  const setUser = (userData) => {
    setUserState(userData);
    safeLocalStorage.setItem('user', JSON.stringify(userData));
  };

  const logoutUser = () => {
    setUserState(null);
    safeLocalStorage.removeItem('user');
  };

  return (
    <UserContext.Provider value={{ user, setUser, logoutUser }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);
